import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import Checkbox from "../../../atoms/input/checkbox";
import GrayBtn from "../../../atoms/button/grayBtn";
import PretendardText from "../../../atoms/text/pretendardText";
import MemberApi from "../../../../api/member.api";
import { toast } from "react-toastify";
import { toastMsg } from "../../../../util/toastMsg";
import { errorHandler } from "../../../../util/errorHandler";

const ChangeMSGrades = ({
  userCheckedIdList,
  getMemberList,
  sessionStorageInit,
  setButtonGroupOpen,
  setButtonGroupFilterOpen,
}) => {
  const navigate = useNavigate();
  const [alarmFlag, setAlarmFlag] = useState(false);

  const [membershipGradeValue, setMembershipGradeValue] = useState(0);
  const membershipGradesList = [
    {
      title: "한 등급씩 올리기",
      value: 1,
    },
    {
      title: "한 등급씩 낮추기",
      value: 2,
    },
    {
      title: "최고 등급으로 올리기",
      value: 3,
    },
    {
      title: "최저 등급으로 낮추기",
      value: 4,
    },
  ];
  const [levelGradeValue, setLevelGradeValue] = useState(0);
  const levelGradesList = [
    {
      title: "한 레벨씩 올리기",
      value: 1,
    },
    {
      title: "한 레벨씩 낮추기",
      value: 2,
    },
    {
      title: "최고 레벨로 올리기",
      value: 3,
    },
    {
      title: "최저 레벨로 낮추기",
      value: 4,
    },
  ];

  const editMembershipLevelFunc = async () => {
    try {
      let memberIdsTemp = userCheckedIdList.map((item) => item.id);

      const data = {
        memberIds: memberIdsTemp,
        membershipChangeFlag: membershipGradeValue,
        writingLevelChangeFlag: levelGradeValue,
        alarmFlag: alarmFlag,
      };

      await MemberApi.memberShipLevel(data);

      getMemberList();
      toast(toastMsg.create);
      setButtonGroupOpen(false);
      sessionStorageInit();
    } catch (error) {
      errorHandler(error);
    }
  };

  return (
    <FilterWrapper
      style={{
        width: 230,
        top: 36,
        padding: 16,
      }}
    >
      {/* 회원등급 변경 */}
      <FilterTitle
        style={{
          marginBottom: 2,
        }}
      >
        회원등급 변경
      </FilterTitle>
      <FilterSubTitle
        style={{
          marginBottom: 16,
        }}
      >
        (일반회원 - 일년회원 - 평생회원)
      </FilterSubTitle>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 11,
        }}
      >
        {membershipGradesList.map((item) => {
          return (
            <CheckboxWrapper
              onClick={() => {
                setMembershipGradeValue(item.value);
              }}
            >
              <Checkbox
                checked={membershipGradeValue === item.value}
                onChange={() => {
                  setMembershipGradeValue(item.value);
                }}
              />
              <CheckboxText
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  lineHeight: "21.5px",
                  color: "#aaa",
                }}
              >
                {item.title}
              </CheckboxText>
            </CheckboxWrapper>
          );
        })}
      </div>
      <span
        style={{
          display: "block",
          width: "100%",
          height: 0.5,
          background: "rgba(255, 255, 255, 0.12)",
          margin: "12px 0px",
        }}
      />
      {/* 회원레벨 변경 */}
      <FilterTitle
        style={{
          marginBottom: 2,
        }}
      >
        회원레벨 변경
      </FilterTitle>
      <FilterSubTitle
        style={{
          marginBottom: 16,
        }}
      >
        (Lv.1 뉴비 - Lv.2 루키 - Lv.3 중수 - Lv.4 고수 - Lv.5 마스터)
      </FilterSubTitle>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 11,
        }}
      >
        {levelGradesList.map((item) => {
          return (
            <CheckboxWrapper
              onClick={() => {
                setLevelGradeValue(item.value);
              }}
            >
              <Checkbox
                checked={levelGradeValue === item.value}
                onChange={() => {
                  setLevelGradeValue(item.value);
                }}
              />
              <CheckboxText
                style={{
                  fontSize: "15px",
                  fontWeight: "500",
                  lineHeight: "21.5px",
                  color: "#aaa",
                }}
              >
                {item.title}
              </CheckboxText>
            </CheckboxWrapper>
          );
        })}
      </div>
      <span
        style={{
          display: "block",
          width: "100%",
          height: 0.5,
          background: "rgba(255, 255, 255, 0.12)",
          margin: "16px 0px 12px 0px",
        }}
      />
      {/* 알림 전송하기 */}
      <CheckboxWrapper
        onClick={() => {
          setAlarmFlag(!alarmFlag);
        }}
      >
        <Checkbox
          checked={alarmFlag}
          onChange={() => {
            setAlarmFlag(!alarmFlag);
          }}
        />
        <CheckboxText
          style={{
            fontSize: "15px",
            fontWeight: "500",
            lineHeight: "21.5px",
            color: "#aaa",
          }}
        >
          알림 전송하기
        </CheckboxText>
      </CheckboxWrapper>
      {/* 취소/적용 버튼 영역 */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          gap: 8,
          marginTop: 20,
        }}
      >
        <GrayBtn
          style={{
            backgroundColor: "#313233",
          }}
          onClick={() => {
            setButtonGroupFilterOpen((prev) => ({
              ...Object.keys(prev).reduce(
                (acc, key) => ({ ...acc, [key]: false }),
                {}
              ),
              gradeAndLevel: !prev.gradeAndLevel,
            }));
          }}
        >
          취소
        </GrayBtn>
        <GrayBtn
          style={{
            backgroundColor: "#313233",
          }}
          onClick={() => {
            editMembershipLevelFunc();

            setButtonGroupFilterOpen({
              group: false,
              gradeAndLevel: false,
              point: false,
              coupon: false,
              read: false,
              write: false,
            });
          }}
        >
          적용
        </GrayBtn>
      </div>
    </FilterWrapper>
  );
};

export default ChangeMSGrades;

const FilterWrapper = styled.div.attrs((props) => {})`
  padding: 10px;
  border-radius: 3px;
  background: #272829;
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.25);
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 48px;
  z-index: 5;
`;

const FilterTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 13px;
  line-height: 18.75px;
  color: #aaa;
`;

const FilterSubTitle = styled(PretendardText).attrs((props) => {})`
  font-weight: 500;
  font-size: 12px;
  line-height: 18.75px;
  color: rgba(181, 181, 181, 0.5);
`;

const CheckboxWrapper = styled.div.attrs((props) => {})`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const CheckboxText = styled(PretendardText).attrs((props) => {})`
  font-size: 15px;
  font-weight: 500;
  line-height: 21.5px;
  color: #aaa;

  cursor: pointer;
`;
